
import React from 'react';
import ReactDOM from 'react-dom';
import Sidebar from '/home/circleci/app/node_modules/@fiverr-private/sidebar/entries/Guest';

const element = typeof document !== 'undefined' && document.querySelector('#Sidebar');

if (element) {
    const props = window.initialData['Sidebar'];

    ReactDOM.hydrate(
        <Sidebar {...props}/>,
        element
    );
}

export default Sidebar;
